import { render, staticRenderFns } from "./formThreads.vue?vue&type=template&id=df902036&"
import script from "./formThreads.vue?vue&type=script&lang=js&"
export * from "./formThreads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports